module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"egremont-ii\"-in-pasadena-california-20033692ec1074bb11890b2da105a6c2.png";